import * as React from "react";
import ReactInputMask from 'react-input-mask';
import { Controller } from "react-hook-form";
import { IInputText } from "../types/dataForm/types";
import { TextField } from "@mui/material";

export interface IInputMask extends IInputText {
  mask?: any;
}

export default function InputMask({
  name,
  form,
  mask,
  readonly,
  label,
  type,
}: IInputMask) {
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <ReactInputMask mask={mask} onChange={onChange} value={value}>
          
        </ReactInputMask>
      )}
    />
  );
}
